import { NavigationItemsProvider } from "./app/NavigationItemsContext";
import { ApplicationProvider } from "./app/ApplicationsContext";
import { ApplicationManagerContextProvider } from "./app/ApplicationManagerContext";
import SnackbarContextProvider from "./app/SnackbarContext";
import { SysadminContextProvider } from "./app/SysadminContext";
import { SeatApplicationManagerContextProvider } from "./app/SeatApplicationManagerContext";
import { AppContextProvider } from "./app/AppContext";
import { AIAssistantContextProvider } from "./app/AIAssistantContext";
import { AIAssistantChatContextProvider } from "./app/AIAssistantChatContext";
import { SysadminAIAssistantTemplateContextProvider } from "./app/SysadminAIAssistantTemplateContext";
import { SysadminAgentTemplateContextProvider } from "./app/SysadminAgentTemplateContext";
import { AgentContextProvider } from "./app/AgentContext";

const AppContexts = ({ children }) => {
  return (
    <AppContextProvider>
      <NavigationItemsProvider>
        <SysadminContextProvider>
          <SysadminAIAssistantTemplateContextProvider>
           <SysadminAgentTemplateContextProvider>
            <ApplicationProvider>
              <ApplicationManagerContextProvider>
                <SeatApplicationManagerContextProvider>
                  <AIAssistantContextProvider>
                    <AIAssistantChatContextProvider>
                      <AgentContextProvider>
                        <SnackbarContextProvider>
                          {children}
                        </SnackbarContextProvider>
                      </AgentContextProvider>
                    </AIAssistantChatContextProvider>
                  </AIAssistantContextProvider>
                </SeatApplicationManagerContextProvider>
              </ApplicationManagerContextProvider>
            </ApplicationProvider>
           </SysadminAgentTemplateContextProvider>
          </SysadminAIAssistantTemplateContextProvider>
        </SysadminContextProvider>
      </NavigationItemsProvider>
    </AppContextProvider>
  );
};

export default AppContexts;
